<div class="esf-pagination esf-pagination--inline">
  <div class="esf-pagination__unit esf-pagination__unit--options">
    <div class="esf-pagination__quantities">
      <span class="esf-pagination__quantities-label" i18n="@@general.label.view">View</span>
      <span *ngFor="let view of viewList"
            class="esf-pagination__quantity"
            [class.-is-current]="view === pager.pageSize"
            (click)="setView(view)">{{ view }}</span>
    </div>
    <span class="esf-pagination__meta">{{ showingText }}</span>
  </div>
  <div class="esf-pagination__unit esf-pagination__unit--navigator">
    <span class="esf-pagination__arrow" *ngIf="pager.currentPage === 1">
      <svg class="esf-icon esf-icon--medium first-page disabled" width="16" height="16">
        <use xlink:href="#esf-icon-minimal-left"></use>
      </svg>
    </span>

    <a class="esf-pagination__arrow" (click)="setPage(pager.currentPage - 1)" *ngIf="pager.currentPage > 1">
      <svg class="esf-icon esf-icon--darkest first-page" width="16" height="16">
        <use xlink:href="#esf-icon-minimal-left"></use>
      </svg>
    </a>

    <div class="esf-pagination__pages">
      <ng-container *ngFor="let page of pager.pages">
        <a
           class="esf-pagination__page"
           [ngClass]="{ '-is-current': page === pager.currentPage, 'esf-pagination__page--neighbor': page !== pager.currentPage }"
           (click)="setPage(page)"
           *ngIf="page !== '...'">{{ page }}</a>

        <span class="esf-pagination__page esf-pagination__page--neighbor" *ngIf="page === '...'">{{ page }}</span>
      </ng-container>
    </div>

    <span class="esf-pagination__arrow" *ngIf="pager.currentPage === pager.endPage">
      <svg class="esf-icon esf-icon--medium last-page disabled" width="16" height="16">
        <use xlink:href="#esf-icon-minimal-right"></use>
      </svg>
    </span>

    <a class="esf-pagination__arrow" (click)="setPage(pager.currentPage + 1)" *ngIf="pager.currentPage < pager.endPage">
      <svg class="esf-icon esf-icon--darkest last-page" width="16" height="16">
        <use xlink:href="#esf-icon-minimal-right"></use>
      </svg>
    </a>

  </div>
</div>
